// ============================================
// 1. cities.js - 城市管理（可复用）
// ============================================
export const cities = {
  toronto: {
    id: "toronto",
    name: "Toronto",
    image: "images/cities/toronto.jpg",
    description: "Canada's largest city with iconic landmarks and vibrant neighborhoods."
  },
  niagaraFalls: {
    id: "niagaraFalls",
    name: "Niagara Falls",
    image: "images/cities/niagara-falls.jpg",
    description: "Witness the spectacular power of Niagara Falls and explore wine country."
  },
  ottawa: {
    id: "ottawa",
    name: "Ottawa",
    image: "images/cities/ottawa.jpg",
    description: "Canada's capital with Parliament Hill, museums, and river cruises."
  },
  montreal: {
    id: "montreal",
    name: "Montreal",
    image: "images/cities/montreal.jpg",
    description: "Immerse in artistic culture, gastronomy, and historic Old Town."
  },
  quebecCity: {
    id: "quebecCity",
    name: "Quebec City",
    image: "images/cities/quebec-city.jpg",
    description: "North America's only walled city with charm and historic character."
  },
  milan: {
    id: "milan",
    name: "Milan & Lake Como",
    image: "images/tours/id2/milan.jpg",
    description: "Global fashion hub and stunning villas surrounded by the Alps."
  },
  dolomites: {
    id: "dolomites",
    name: "Dolomites",
    image: "images/tours/id2/dolomites.jpg",
    description: "Majestic peaks and jagged skylines, a paradise for nature lovers."
  },
  venice: {
    id: "venice",
    name: "Venice",
    image: "images/tours/id2/venice.jpg",
    description: "Jewel of Italy, known for intricate canals and deep cultural heritage."
  },
  florence: {
    id: "florence",
    name: "Tuscany & Florence",
    image: "images/tours/id2/florence.jpg",
    description: "Immerse in the Renaissance art of Florence and the rolling hills, vineyards, and cypress roads of Tuscany."
  },
  amalfiCoast: {
    id: "amalfiCoast",
    name: "Amalfi Coast",
    image: "images/tours/id2/amalfi-coast.jpg",
    description: "Breathtaking cliffside views and sparkling Mediterranean waters."
  },
  rome: {
    id: "rome",
    name: "Rome",
    image: "images/tours/id2/rome.jpg",
    description: "The Eternal City with glorious ancient ruins and rich history."
  }
};